module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAABR0lEQVR42u3aTUrDQBjG8elHsC01tYjdFPwsduemB3DtHTyAB+h5uhC6Kd0Jbr1AELxP4TXP0BathFRFiDP/xQOTmczi/ZF5k0WcmbmYE3XxAAAAAAAAAAAAAAAAkOe1f21/mdXboFIBAAAAAAAAAAAAAAAAAAD4NsAyPbdFehYvwEP72CdagFHjwCdKAD3+Lt+maBw0wHPv0ubp6afct/pbAI1317UnGICXoyu7Tbrbgsuie7UnuCMw7ZxY4mqFhWtN9wTdA/R4D+vJl+I1p7Wy/W52V6n8qAmO886/CzDe823w7wHU3DZFd2p1n811UeMLCkBnXMXeNFv21Lvw0VhzZec/CIBJs+2//rIPc9n6q1BrQQOo0MfD4kantSyGJvibAAAAAAAAAAAAAAAAAAAAAFBFAP4UBQAAAAAAAAAAAAAAgKjyDqrylr7TSlDYAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/Guinea-Bissau.png
// module id = eIad
// module chunks = 0 62 63